import EmailBox           from './components/EmailBox';
import PageContainer      from '@/components/pageContainer/PageContainer';
import PageTitle          from '@/components/pageTitle/PageTitle';
import PasswordBox        from './components/PasswordBox';
import { useTranslation } from 'react-i18next';

const SecurityPage = () => {
	const { t } = useTranslation();
	return (
		<PageContainer>
			<PageTitle>
				{t('pages.security.label')}
			</PageTitle>
			<EmailBox />
			<PasswordBox />
		</PageContainer>
	);
};

export default SecurityPage;